import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
	state: {
		data: {}
	},
	mutations: {
		SAVE_DATA(state, payload) {
			state.data = payload
		}
	},
	getters: {
		componentType: (state) => {
			return state.data.paragraaf[0].__component;
		},
		title: (state) => state['data']['title'],
		subtitle: (state) => state['data']['subtitle'],
		swiperArticles: (state) => state['data']['articles'],
		featured: (state) => state['data']['featured']
	},
	actions: {
		loadData({ commit, state }) {
			return new Promise((resolve, reject) => {
				axios
					.get(process.env.VUE_APP_API_URL + `?t=${new Date().getTime()}`)
					.then((result) => {
						// console.log('store data hook', result.data)
						commit('SAVE_DATA', result.data)
						resolve()
					})
					.catch((error) => {
						reject()
						throw new Error(`API ${error}`)
					})
			})
		}
	},
	modules: {}
})
